import(/* webpackMode: "eager" */ "/codebuild/output/src2103436129/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
